(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-jojo-campaign-video"] && !Shopify.designMode) return;
  try {
    (function () {
    function initProductJojoCampaignVideo(root) {
      if (!root || root.dataset.productJojoCampaignVideoReady === 'true') return;
      root.dataset.productJojoCampaignVideoReady = 'true';

      var hit = root.querySelector('[data-product-jojo-campaign-video-open]');
      var modal = root.querySelector('[data-product-jojo-campaign-video-modal]');
      var filePlayer = modal ? modal.querySelector('.product-jojo-campaign-video__player--file') : null;
      var youtubePlayer = modal ? modal.querySelector('[data-youtube-id]') : null;
      var youtubeId = youtubePlayer ? youtubePlayer.getAttribute('data-youtube-id') : '';
      var lastFocus = null;
      var isOpen = false;

      function lockScroll(lock) {
        document.documentElement.classList.toggle('product-jojo-campaign-video-open', lock);
      }

      function closeModal() {
        if (!modal || !isOpen) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        isOpen = false;
        if (filePlayer) {
          filePlayer.pause();
          try {
            filePlayer.currentTime = 0;
          } catch (e) {}
        }
        if (youtubePlayer) youtubePlayer.removeAttribute('src');
        lockScroll(false);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }

      function openModal(trigger) {
        if (!modal || isOpen) return;
        if (!filePlayer && !youtubeId) return;
        lastFocus = trigger || document.activeElement;
        if (filePlayer) {
          var playPromise = filePlayer.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else if (youtubePlayer) {
          youtubePlayer.src = 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0';
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        isOpen = true;
        lockScroll(true);
        var closeBtn = modal.querySelector('.product-jojo-campaign-video__close');
        if (closeBtn) closeBtn.focus();
      }

      if (hit) {
        hit.addEventListener('click', function (event) {
          event.preventDefault();
          openModal(hit);
        });
      }

      root.addEventListener('click', function (event) {
        var closeEl = event.target.closest('[data-product-jojo-campaign-video-close]');
        if (closeEl && root.contains(closeEl)) {
          event.preventDefault();
          closeModal();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen) closeModal();
      });

      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(root)) return;
        closeModal();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-product-jojo-campaign-video]').forEach(initProductJojoCampaignVideo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-product-jojo-campaign-video]');
      if (root) {
        root.dataset.productJojoCampaignVideoReady = 'false';
        initProductJojoCampaignVideo(root);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
